import axiosInstance from 'ns_libs/nsAxios';
import { useMutation } from '@tanstack/react-query';
import API_ENDPOINTS from 'services/urls';

interface GenerateInvestmentMemoRequest {
    organizationId: string;
    dealId: number;
    proFormaId: number;
    addressFields: {
        address: string;
        city: string;
        state: string;
        zipCode: string;
    };
}

interface HeaderDescription {
    header: string;
    description: string;
}

export interface GenerateInvestmentMemoResponse {
    tagline: string;
    opportunity: string;
    investmentHighlights: HeaderDescription[];
    locationProximityDrivers: HeaderDescription[];
    marketOverviewFundamentals: HeaderDescription[];
}

const generateInvestmentMemo = async ({
    organizationId,
    dealId,
    proFormaId,
    addressFields,
}: GenerateInvestmentMemoRequest): Promise<GenerateInvestmentMemoResponse> => {
    const endpoint = `${API_ENDPOINTS.INVESTMENT_MEMO.GENERATE_AI_CONTENT(dealId, proFormaId)}?organizationId=${organizationId}`;
    const response = await axiosInstance.post(endpoint, { ...addressFields });
    return response.data;
};

const useGenerateInvestmentMemo = () => useMutation({
    mutationFn: generateInvestmentMemo,
});

export default useGenerateInvestmentMemo;
